// extracted by mini-css-extract-plugin
module.exports = {"footer":"op8xxV","buttonFooter":"sXBzsv"};